<template>
	<sf-modal-layout size="xl" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<part-dtl-popup-search ref="partDtlPopupSearch" :scrId="scrId" :propPartNo="this.propPartNo" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="pb-3 border-0 bg-transparent h-100">
					<part-dtl-popup-table ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';

import PartDtlPopupSearch from './Search/PartDtlPopupSearch.vue';
import PartDtlPopupTable from './Table/PartDtlPopupTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PartDtlPopupSearch, PartDtlPopupTable },
	data() {
		return {
			show: false,
			propPartNo: ''
		};
	},
	created() {
		// console.clear();
		//들어오자마자 state 초기화 하는 방법
		this.setSearchPopupStateInit_();
		// this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		title() {
			return this.getMessage_('QWCC001882'); // 부품검사 정보조회
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.show = true;
			this.propPartNo = param;
			// console.log('open param ::', param);
			// console.log('this.propPartNo ::', this.propPartNo);
			if (this.$refs.partDtlPopupSearch != undefined) {
				this.$refs.partDtlPopupSearch.resetParam(param);
				//this.$refs.partDtlPopupSearch.searchList(param);
			}
		},
		close() {
			this.setSearchPopupCommInit_(); //초기화
			this.$refs.partDtlPopupSearch.resetParam();
			this.show = false;
		},
		reload() {
			this.$refs.partDtlPopupSearch.searchList();
		},
		sendData(row) {
			this.$emit('SendData', row);
			this.close();
		}
	}
};
</script>

<style></style>
